
import React, { useState } from 'react'

import {
  Heading,
  Avatar,
  Box,
  Center,
  Text,
  Button,
  useColorModeValue,
} from '@chakra-ui/react';

import ReactPlayer from 'react-player/lazy'

import { FaPlay, FaStop } from 'react-icons/fa';

import SocialButtons from '../socialButtons/SocialButtons';

import './userCard.scss';

const defaultAvatar = 'https://images.unsplash.com/photo-1520810627419-35e362c5dc07?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ'


export default function UserCard(props) {

  const [playing, setPlaying] = useState(false);

  const videoEnded = () => {
    console.log('VIDE ENDED');
    setPlaying(false);
  }

  return (
    <Center py={6} className="card-wrapper">
      <Box
        className="card"
        w={'full'}
        bg={useColorModeValue('white', 'gray.900')}
        boxShadow={'2xl'}
        rounded={'lg'}
        p={6}
        textAlign={'center'}
      >
      <div className="avatar-video-wrapper">
        <Avatar
          className={playing ? 'hide' : 'show'}
          size={'3xl'}
          src={
            props.image || defaultAvatar
          }
          alt={'Avatar Alt'}
          mb={4}
          pos={'relative'}
          _after={{
            content: `"${ props.emoji || ''}"`,
            w: 12,
            h: 12,
            fontSize: '30px',
            bg: props.emojiColour || '',
            border: props.emojiColour ? '2px solid white' : '',
            rounded: 'full',
            pos: 'absolute',
            bottom: 1,
            right: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
          }}
        />
        <span
          className={`player-wrapper ${!playing ? 'hide' : 'show'}`}
        >
          <ReactPlayer
            className='react-player'
            url={props.video}
            width='100%'
            height='100%'
            playing={playing}
            onEnded={() => videoEnded()}
          />
        </span>
      </div>
        <Heading fontSize={'3xl'} fontFamily={'body'} color={'brand.main'}>
          { props.name || 'no name'}
        </Heading>
        <Text fontSize={'sm'} fontWeight={600} color={'brand.black'} mb={4}>
        { props.company || 'no company'}
        </Text>
        <Text
          textAlign={'center'}
          color={'brand.black'}
          px={3}>
          { props.info || ''}
        </Text>
        <Button
          onClick={() => setPlaying(!playing)}
          rightIcon={playing ? <FaStop/> : <FaPlay />}
          rounded={'full'}
          bg={'brand.main'}
          color={'white'}
          _hover={{
          bg: 'brand.dark',
          }}
        >
          { playing ? 'Stop' : 'My Experience'}
        </Button>
        <SocialButtons
          linkedin={props.linkedin || null}
          github={props.github || null}
          twitter={props.twitter || null}
          link={props.link || null}
        />
      </Box>
    </Center>
  );
}